module.exports = __webpack_public_path__ + "img/bitcoin.a552edcd.png";